export enum ActionType {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  UPDATE_UNREAD_MESSAGES = 'UPDATE_UNREAD_MESSAGES',
  UPDATE_CLIENT = 'UPDATE_CLIENT'
}
